import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["signup.factoringProfile"],
  payload => payload
);
